// extracted by mini-css-extract-plugin
export default {"headline":"cancel-option-confirmation_headline__bY-oN","buttons":"cancel-option-confirmation_buttons__J0XZq","center":"cancel-option-confirmation_center__f0pSJ"};